import * as React from 'react';
import * as $ from 'jquery';
import { NavMenu } from './NavMenu';
import { NavLink, Link } from 'react-router-dom';
import { fetchApi } from '../services/api';
import GlobalSearch from './GlobalSearch';
import { History } from 'history';
const DocumentTitle = require('react-document-title');

type Props = {
    history: History;
}

type State = {
    TenantName: string;
    FacilityName: string;
    Facilities: FacilityData[];
    Links: ApiLink[];
    UserName: string;
}

type FacilityData = {
    FacilityId: number;
    Name: string;
    Phone: string;
    AcceptingApplications: boolean;
}

export class Layout extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            TenantName: '',
            FacilityName: '',
            Facilities: [],
            Links: [],
            UserName: ''
        }

        this.hideMenu = this.hideMenu.bind(this);
        this.searchClick = this.searchClick.bind(this);
        this.setFacility = this.setFacility.bind(this);
        this.clearFacility = this.clearFacility.bind(this);
    }

    public componentWillMount() {
        this.getFacilities();
        this.getUserInfo();
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title='Daycarium' />
            <nav className="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 d-print-none shadow">
                <div className="dropdown col-sm-3 col-md-2 mr-0 d-none d-md-block">
                    <button className='navbar-brand dropdown-toggle' data-toggle="dropdown" type="button">
                        {this.state.FacilityName || this.state.TenantName}
                    </button>
                    <div className="dropdown-menu">
                        <a href="#" className="dropdown-item font-weight-bold" onClick={this.clearFacility}>{this.state.TenantName}</a>
                        <div className="dropdown-divider"></div>
                        {this.state.Facilities.map((facility, index) => {
                            return <a
                                key={index}
                                href="#"
                                className="dropdown-item"
                                onClick={(e) => this.setFacility(e, facility.FacilityId)}
                            >
                                {facility.Name}
                            </a>
                        })}
                    </div>
                </div>
                <div className="dropdown d-block d-md-none">
                    <button className='navbar-brand dropdown-toggle' data-toggle="dropdown" type="button">
                        {this.state.FacilityName || this.state.TenantName}
                    </button>
                    <div className="dropdown-menu">
                        <a href="#" className="dropdown-item font-weight-bold" onClick={this.clearFacility}>{this.state.TenantName}</a>
                        <div className="dropdown-divider"></div>
                        {this.state.Facilities.map((facility, index) => {
                            return <a
                                key={index}
                                href="#"
                                className="dropdown-item"
                                onClick={(e) => this.setFacility(e, facility.FacilityId)}
                            >
                                {facility.Name}
                            </a>
                        })}
                    </div>
                </div>
                <button className="navbar-toggler d-block d-md-none" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="w-100 d-none d-md-block">
                    <GlobalSearch history={this.props.history} />
                </div>
                <div className="dropdown d-none d-md-block" id="navbarUserDropdown">
                    <a className="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    </a>
                    <div className="dropdown-menu dropdown-menu-right">
                        <button className="dropdown-item font-weight-bold" type="button">{this.state.UserName}</button>
                        <div className="dropdown-divider"></div>
                        <Link to='/user/changePassword' className="dropdown-item" href="#">Change Password</Link>
                        <Link to='/logout' className="dropdown-item" href="#">Sign out</Link>
                    </div>
                </div>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <input className="form-control form-control-dark w-100" type="text" placeholder="Search" aria-label="Search" onFocus={this.searchClick} />
                    <ul className="navbar-nav px-3">
                        {this.state.Links.find(x => x.Rel === "Dashboard") && <li className="nav-item">
                            <NavLink to={ '/home' } className="nav-link" onClick={this.hideMenu}>Dashboard</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Users") && <li className="nav-item">
                            <NavLink to={ '/users' } className="nav-link" onClick={this.hideMenu}>Users</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Accounts") && <li className="nav-item">
                            <NavLink to={ '/accounts' } className="nav-link" onClick={this.hideMenu}>Accounts</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Children") && <li className="nav-item">
                            <NavLink to={ '/children' } className="nav-link" onClick={this.hideMenu}>Children</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Attendance") && <li className="nav-item">
                            <NavLink to={ '/attendance' } className="nav-link" onClick={this.hideMenu}>Attendance</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Facilities") && <li className="nav-item">
                            <NavLink to={ '/facilities' } className="nav-link" onClick={this.hideMenu}>Facilities</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Classrooms") && <li className="nav-item">
                            <NavLink to={ '/classrooms' } className="nav-link" onClick={this.hideMenu}>Classrooms</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Instructors") && <li className="nav-item">
                            <NavLink to={'/instructors'} className="nav-link" onClick={this.hideMenu}>Our Instructors</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Documents") && <li className="nav-item">
                            <NavLink to={'/documents'} className="nav-link" onClick={this.hideMenu}>Documents</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Teachers") && <li className="nav-item">
                            <NavLink to={'/teachers'} className="nav-link" onClick={this.hideMenu}>School Teachers</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Schools") && <li className="nav-item">
                            <NavLink to={'/schools'} className="nav-link" onClick={this.hideMenu}>Schools</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Holidays") && <li className="nav-item">
                            <NavLink to={ '/holidays' } className="nav-link" onClick={this.hideMenu}>Holidays</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Invoices") && <li className="nav-item">
                            <NavLink to={ '/invoices' } className="nav-link" onClick={this.hideMenu}>Invoices</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Receipts") && <li className="nav-item">
                            <NavLink to={ '/receipts' } className='nav-link' onClick={this.hideMenu}>Receipts</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Notices") && <li className="nav-item">
                            <NavLink to={ '/notices' } className='nav-link' onClick={this.hideMenu}>Notices</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Agreements") && <li className="nav-item">
                            <NavLink to={ '/agreements' } className='nav-link' onClick={this.hideMenu}>Agreements</NavLink>
                        </li>}
                        <li className="nav-item">
                            <span className="navbar-text font-weight-bold">Reports</span>
                        </li>
                        {this.state.Links.find(x => x.Rel === "Schedules") && <li className="nav-item">
                            <NavLink to={ '/reports/attendancereport' } className='nav-link' onClick={this.hideMenu}>Schedules</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "ExpiringRates") && <li className="nav-item">
                            <NavLink to={ '/reports/expiringRates' } className='nav-link' onClick={this.hideMenu}>Expiring Rates</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "Payments") && <li className="nav-item">
                            <NavLink to={ '/reports/payments' } className='nav-link' onClick={this.hideMenu}>Payments</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "OutstandingBalances") && <li className="nav-item">
                            <NavLink to={ '/reports/outstandingBalances' } className='nav-link' onClick={this.hideMenu}>Outstanding Balances</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "UpcomingBirthdays") && <li className="nav-item">
                            <NavLink to={ '/reports/upcomingBirthdays' } className='nav-link' onClick={this.hideMenu}>Upcoming Birthdays</NavLink>
                        </li>}
                        {this.state.Links.find(x => x.Rel === "RetirableAccounts") && <li className="nav-item">
                            <NavLink to={ '/reports/retirableAccounts' } className='nav-link' onClick={this.hideMenu}>Retirable Accounts</NavLink>
                        </li>}
                        <li className="nav-item text-nowrap">
                            <Link to='/logout' className="nav-link" href="#">Sign out</Link>
                        </li>
                    </ul>
                    <div className="text-center">
                        <a href="#" onClick={this.toggleDarkMode}>
                            {localStorage.getItem("darkmode") === null && <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-moon"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>}
                            {localStorage.getItem("darkmode") !== null && <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-sun"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>}
                        </a>
                    </div>
                    <br />
                </div>
            </nav>
            <div className="container-fluid">
                <div className="row">
                    <NavMenu links={this.state.Links} />
                    <main role="main" className="main-page col-md-9 ml-sm-auto col-lg-10 px-4">
                        { this.props.children }
                    </main>
                </div>
            </div>
        </React.Fragment>;
    }

    private toggleDarkMode(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        e.preventDefault();

        if (localStorage.getItem("darkmode")) {
            localStorage.removeItem("darkmode");
        } else {
            localStorage.setItem("darkmode", "true");
        }

        location.reload();
    }

    private getUserInfo() {
        fetchApi('/api/User/UserInfo')
            .then((data: { TenantName: string, Links: ApiLink[], UserName: string }) => {
                this.setState({ TenantName: data.TenantName, Links: data.Links, UserName: data.UserName });
            });
    }

    private getFacilities() {
        fetchApi('/api/Facilities/List')
            .then((data: FacilityData[]) => {

                var activeFacilityId = parseInt(localStorage.getItem("FACILITY_ID") || "0");
                var activeFacility = data.find(x => activeFacilityId === x.FacilityId);
                if (activeFacility) {
                    this.setState({ FacilityName: activeFacility.Name });
                } else if (data.length === 1) {

                    // Default if only 1 facility
                    this.setState({ FacilityName: data[0].Name });
                    localStorage.setItem("FACILITY_ID", data[0].FacilityId.toString());
                }

                this.setState({ Facilities: data });
            });
    }

    private setFacility(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, facilityId: number) {
        e.preventDefault();

        localStorage.setItem("FACILITY_ID", facilityId.toString());
        location.reload();
    }

    private clearFacility(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        e.preventDefault();

        localStorage.removeItem("FACILITY_ID");
        location.reload();
    }

    private hideMenu() {
        $(".navbar-collapse.collapse.show").removeClass('show');
    }

    private searchClick() {
        this.hideMenu();
        this.props.history.push('/search');
    }
}
